import React from "react";

import { Skeleton } from "@mui/material";

export const SkeletonWrapper = ({ children, sx, isLoading, count, variant = "text" }) => {
  if (!isLoading) {
    return <>{children}</>;
  }

  if (variant === "textfield") {
    return (
      <>
        <Skeleton variant="text" width="50%" sx={{ mb: "6px", height: "22px", fontSize: "18px" }} />
        <Skeleton variant="rectangular" height={48} sx={sx} />
      </>
    );
  }

  return Array(count || 1)
    .fill("")
    .map((item, index) =>
      React.Children.map(children, (child, childIndex) => (
        <Skeleton variant={variant} sx={sx} key={index + "/" + childIndex}>
          {child}
        </Skeleton>
      ))
    );
};
